import { get } from 'lodash';

import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';

import { ticketState, ticketType, paymentMethod } from '@modules/tickets/_ticketsEnums';

export default [
  {
    label: 'Číslo série',
    field: 'seriesNumber',
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Písmeno',
    field: 'letter',
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Evidenční číslo',
    field: 'number',
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Strážník',
    field: 'employee.name',
    displayField: 'employee',
    mapper: o => get(o, 'fullName'),
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Stav',
    field: 'state.id',
    displayField: 'state',
    type: ColumnType.ENUM,
    enum: ticketState,
    width: 200
  },
  {
    label: 'Hodnota',
    field: 'value',
    type: ColumnType.NUMBER,
    width: 100
  },
  {
    label: 'Datum zavedení',
    field: 'issueDate',
    type: ColumnType.DATE,
    compact: true,
    width: 100
  },
  {
    label: 'Datum užití',
    field: 'useDate',
    type: ColumnType.DATE,
    compact: true,
    width: 100
  },
  {
    label: 'Datum zaplacení',
    field: 'collectDate',
    type: ColumnType.DATE,
    compact: true,
    width: 100
  },
  {
    label: 'Vymáháno dne',
    field: 'demandDate',
    type: ColumnType.DATE,
    compact: true,
    width: 100
  },
  {
    label: 'Odepsáno dne',
    field: 'deprecationDate',
    type: ColumnType.DATE,
    compact: true,
    width: 100
  },
  {
    label: 'Datum zrušení',
    field: 'cancelDate',
    type: ColumnType.DATE,
    compact: true,
    width: 100
  },
  {
    label: 'Datum odevzdání hotovosti',
    field: 'cashDate',
    type: ColumnType.DATE,
    compact: true,
    width: 100
  },
  {
    label: 'Platební metoda',
    field: 'paymentMethod',
    displayField: 'paymentMethod',
    type: ColumnType.TEXT,
    mapper: o => {
      const pm = paymentMethod.find(v => v.id === o);
      return pm ? pm.label : '';
    },
    width: 100
  },
  {
    label: 'Typ',
    field: 'type.id',
    displayField: 'type',
    type: ColumnType.ENUM,
    enum: ticketType,
    width: 100
  },
  {
    label: 'Přestupek',
    field: 'delictNumber',
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Přestupce',
    field: 'offender.name',
    displayField: 'offender',
    mapper: o => get(o, 'person.fullName'),
    type: ColumnType.TEXT,
    width: 100
  }
];



// WEBPACK FOOTER //
// ./src/modules/tickets/_ticketsColumns.ts